import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { PurchaseCtaEnum } from '@/services/product.service';
import QueryParamService, { QueryParams } from '@/core/query-params.service';
import { TabEnum } from '@/ui/shared/Tabs.vue';
import ScrollService from '@/core/scroll.service';
import PriceInformationB2BAuthenticated from '@/ui/views/product-details/PriceInformationB2BAuthenticated.vue';
import { computed, ref } from 'vue';

interface ProductInfo {
    image: string | null,
    name: string,
    allowsCordCutting: boolean,
    variantNumber: string,
    eanNumber: string | null,
    deliveryTime: string | null,
    code: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductInformation',
  props: {
    hiddenProperties: { default: () => [] },
    product: { default: null },
    variant: { default: null },
    fallbackVariant: { default: null },
    sparepart: { default: null },
    selectedOptions: { default: null },
    disabled: { type: Boolean },
    allowQuote: { type: Boolean, default: false },
    quoteToggle: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { hiddenProperties: string[], product: ProductBaseViewModel<ProfessionalVariantViewObject> | null, variant: ProfessionalVariantViewObject | null, fallbackVariant: ProfessionalVariantViewObject | null, sparepart: SparePartVariantBaseViewObject | null, selectedOptions: { [key: string]: string } | null, disabled?: boolean, allowQuote: boolean, quoteToggle: boolean }



const isB2BAuthenticated = computed<boolean>(() => store.getters['app/isB2BAuthenticated']);
const theme = computed<ColorTheme>(() => store.getters['app/theme']);

function selectVariantConfig({ variant, pushToHistory }: {variant: VariantBaseViewObject, pushToHistory?: boolean}) : void {
    store.dispatch('catalog/selectVariantConfig', { variant, pushToHistory });
}
function toggleShowVariantDataSpecs(flag: boolean) : void {
    store.dispatch('catalog/toggleShowVariantDataSpecs', flag);
}

const showModal = ref<boolean>(false);

const productInfo = computed<ProductInfo>(() => {
    if (props.sparepart) {
        return sparePartAsProductInfo();
    }
    if (props.variant) {
        return variantAsProductInfo();
    }
    return {
        image: props.fallbackVariant && props.fallbackVariant.images && props.fallbackVariant.images.length >= 1 ? props.fallbackVariant.images[0].url : null,
        name: props.fallbackVariant && props.fallbackVariant.productName,
        allowsCordCutting: props.fallbackVariant && props.fallbackVariant.allowsCordCutting,
        variantNumber: null,
        eanNumber: null,
        deliveryTime: null,
        code: null
    };
});

function sparePartAsProductInfo() {
    return {
        image: props.sparepart.images && props.sparepart.images.length >= 1 ? props.sparepart.images[0].url : null,
        name: props.sparepart.name,
        allowsCordCutting: false,
        variantNumber: props.sparepart.id,
        eanNumber: null,
        deliveryTime: null,
        code: props.sparepart.id
    };
}

function variantAsProductInfo() {
    return {
        image: props.variant.images && props.variant.images.length >= 1 ? props.variant.images[0].url : null,
        name: props.variant.productName,
        allowsCordCutting: props.variant.allowsCordCutting,
        variantNumber: props.variant.sapId,
        eanNumber: props.variant.eanNumber,
        deliveryTime: props.variant.deliveryTime || null,
        code: props.variant.variantCode
    };
}

const showPriceInformation = computed<boolean>(() => {
    if (!props.variant) return false;
    const isAddToBasket = props.variant.purchaseCta === (PurchaseCtaEnum.AddToBasketB2B as any);
    const isShowPricing = props.variant.purchaseCta === (PurchaseCtaEnum.ShowPricingB2B as any);
    const isExpectingPriceInformationView = props.variant.purchaseCta === (PurchaseCtaEnum.GetQuote as any);
    return isAddToBasket || isShowPricing || isExpectingPriceInformationView;
});

const showGetQuote = computed<boolean>(() => {
    return props.variant &&
            (props.variant.purchaseCta === (PurchaseCtaEnum.GetQuote as any) || props.variant.purchaseCta === (PurchaseCtaEnum.GetCutsheet as any));
});

const showDiscontinuedText = computed<boolean>(() => {
    return props.variant && props.variant.purchaseCta === (PurchaseCtaEnum.Discontinued as any);
});

function goToSpareparts() {
    QueryParamService.setQueryParamValue(QueryParams.AccordionState, TabEnum.Spareparts);
    setTimeout(() => {
        const elementToScrollTo = document.getElementById(TabEnum.Spareparts);
        ScrollService.scrollToElement(elementToScrollTo, 0, 300);
    }, 300);
}

function showSpecsOverlay() {
    if (props.variant) {
        selectVariantConfig({ variant: props.variant, pushToHistory: true });
        toggleShowVariantDataSpecs(true);
    }
}

const showAddToBasketB2BButton = computed<boolean>(() => {
    let purchaseCta: any;

    if (props.variant) { purchaseCta = props.variant.purchaseCta; } else if (props.sparepart) { purchaseCta = props.sparepart.purchaseCta; }

    return purchaseCta === (PurchaseCtaEnum.AddToBasketB2B as any);
});

function setShowModal(value: boolean): void {
    showModal.value = value;
}


return { __sfc: true,props, isB2BAuthenticated, theme, selectVariantConfig, toggleShowVariantDataSpecs, showModal, productInfo, sparePartAsProductInfo, variantAsProductInfo, showPriceInformation, showGetQuote, showDiscontinuedText, goToSpareparts, showSpecsOverlay, showAddToBasketB2BButton, setShowModal, PriceInformationB2BAuthenticated }
}

})